/* eslint-disable react-hooks/exhaustive-deps */
import Canonical from "../../../components/common/layout/Canonical";
import ChatbotHeader from "../../../components/common/layout/ChatbotHeader";
import Banner from "../../../components/chatbot/Banner";
import QueriesComponent from "../../../components/chatbot/Queries";

const Queries = () => {
    return (
        <div className="w-full h-full min-h-[calc(100vh-100px)] mm:min-h-[calc(100vh-65px)]">
            <Canonical />
            <div style={{ background: "linear-gradient(178deg, #FFF -54.32%, #C9F8FF 243.19%)" }} className="flex items-center justify-center w-full h-full rounded-b-[25px] lg:rounded-b-[50px] flex-col">
                <ChatbotHeader />
                <Banner status={false} page="queries" />
            </div>
            <QueriesComponent listPage={true} />
        </div>
    );
};

export default Queries;